import { useUnifyAdminStore } from '../../AdminStore';
import { FileUploader } from "react-drag-drop-files";
import * as StyledComponents from '../StyledComponents';
import * as XLSX from "xlsx";
import { t } from 'i18next';

export const BrowseOrDragBulkUpload = (): JSX.Element => {

    const setShowDialogToast = useUnifyAdminStore((state) => state.setShowDialogToast);
    const setDialogToastContent = useUnifyAdminStore((state) => state.setDialogToastContent);

    const updateCreateCampaignData = useUnifyAdminStore((state) => state.updateCreateCampaignData);
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);

    const fileTypes = ["xlsx", "xls"];

    const uploadedEnterprises = campaignItems.uploadedEnterprises;
    const uploadedStores = campaignItems.uploadedStores; 
    
    const handleUpload = async (file: any) => {
        try {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: "array" });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (jsonData.length > 3000) {
                setShowDialogToast(true);
                setDialogToastContent(t('bulkUpload.tooManyRowsCampaign'));
                return;
            }

            const isSingleColumn = jsonData.every((row: any) => row.length === 1);
            if (!isSingleColumn) {
                throw new Error("The file should contain only one column.");
            }

            const values = jsonData.map((row: any) => row[0]).join(",");
            if (values.trim().startsWith('E')) {
                
                updateCreateCampaignData({
                    fieldName: 'uploadedEnterprises',
                    value: values,
                });
                updateCreateCampaignData({
                    fieldName: 'targetEnterprises',
                    value: values,
                });
                const enterpriseArray = values.split(',').map(name => name.trim()).filter(name => name !== "");

                const formattedArray: any = enterpriseArray.map((name, index) => ({
                    isSelected: true,
                    name: name
                }));
                updateCreateCampaignData({
                    fieldName: 'gridEnterpriseData',
                    value: formattedArray,
                });

                if (uploadedStores === undefined) {
                    updateCreateCampaignData({
                        fieldName: 'uploadedStores',
                        value: '',
                    });
                }
            }
            else if (values.trim().startsWith('S')) {
                updateCreateCampaignData({
                    fieldName: 'uploadedStores',
                    value: values,
                });
                updateCreateCampaignData({
                    fieldName: 'targetStores',
                    value: values,
                });
                const storesArray = values.split(',').map((name: string) => name.trim()).filter((name: string) => name !== "");

                const formattedArray: any = storesArray.map((name: string) => ({
                    isSelected: true,
                    name: name
                }));
                updateCreateCampaignData({
                    fieldName: 'gridStoresData',
                    value: formattedArray,
                });
                
                if (uploadedEnterprises === undefined) {
                    updateCreateCampaignData({
                        fieldName: 'uploadedEnterprises',
                        value: '',
                    });
                }
            }

        }
        catch (error: any) {
            console.error("Error processing file:", error.message);
        }
    };

    return (
        <div style={{ width: '95%', paddingTop: '15px', height:'100%' }} data-testid="drag-bulk-upload">
            <FileUploader handleChange={handleUpload} name="file" types={fileTypes} style={{ width: '100%' }}>
                <StyledComponents.StyleduploaderContainer>
                    <StyledComponents.FileUpload ></StyledComponents.FileUpload>
                    <p style={{ fontSize: "14px", paddingTop: '20px' }}>
                        {t('bulkUpload.dragText')} <span style={{ color: "#006CFA" }}>{t('bulkUpload.browseText')}</span>
                    </p>
                </StyledComponents.StyleduploaderContainer>
            </FileUploader>
        </div>
    );
};
